"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmbedOrThrow = void 0;
const getEmbedOrThrow = (embeds) => (embedUrl) => {
    const embed = embeds[embedUrl];
    if (!embed)
        throw new Error(`Missing embed with url '${embedUrl}'`);
    return embed;
};
exports.getEmbedOrThrow = getEmbedOrThrow;
